/**
 * @file list-empty-kind.ts
 * @description Какая пустота у списка диалогов (chat-window-design.md §5):
 * поиск важнее отбора, отбор важнее вкладки.
 */

import type { ChatTab } from "../../lib/api-chat";

export type ListEmptyKind = "all" | "mine" | "archive" | "unassigned" | "search";

/** Какая пустота: поиск важнее отбора, отбор важнее вкладки. */
export function listEmptyKind(tab: ChatTab, unassigned: boolean, search: string): ListEmptyKind {
  if (search.trim()) return "search";
  if (unassigned) return "unassigned";
  return tab;
}

